import { createSelector } from 'reselect';

import { DEFAULT_CONTENT_LANGUAGE, DEFAULT_CONSOLE_LANGUAGE } from 'Console/constants/appConstants';

const getConsoleLanguage = (state) => state.app.language.consoleLanguage;
const getContentLanguage = (state) => state.app.language.contentLanguage;
const getAvailableLangs = (state) => state.app.language.availableLanguages;

/* =========== SELECTORS ============ */
export const selectConsoleLanguage = createSelector(
    [getConsoleLanguage],
    (selectedLang) => selectedLang
);

export const selectConsoleLanguageCode = createSelector(
    [getConsoleLanguage],
    (selectedLang = DEFAULT_CONSOLE_LANGUAGE) => selectedLang.code
);

export const selectContentLanguage = createSelector(
    [getContentLanguage],
    (selectedLang = DEFAULT_CONTENT_LANGUAGE) => selectedLang
);

export const selectContentLanguageCode = createSelector(
    [selectContentLanguage],
    (selectedLang = DEFAULT_CONTENT_LANGUAGE) => selectedLang.code
);

export const selectAvailableLanguages = createSelector([getAvailableLangs], (langs) => langs);
